export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
  { code: 'es', name: 'Español' },
  { code: 'de', name: 'Deutsch' },
  { code: 'ar', name: 'العربية' },
  { code: 'sw', name: 'Kiswahili' },
  { code: 'zh', name: '中文' },
] as const;

export const DEFAULT_CARD_STYLES =
  'bg-white shadow-material border border-gray-100';

export const SECTION_ICON_STYLES = 'h-5 w-5 text-primary';
export const HEADER_ICON_STYLES = 'h-6 w-6 text-primary';
